import { ColumnDef, Row } from "@tanstack/react-table";
import { StudentTestResult } from "./types";
import Tag from "@/components/Tag";
import { buildAvatarDetailsColumn, buildActionColumn } from "@/components/Table";
import { toFormat } from "@/lib/dateHelpers";

interface BuildColumnsProps {
  isCompactLayout: boolean;
  handleViewStudent: (testResult: StudentTestResult) => void;
}

export const buildColumns = ({
  isCompactLayout,
  handleViewStudent
}: BuildColumnsProps): ColumnDef<StudentTestResult>[] => {
  const columns: ColumnDef<StudentTestResult>[] = [
    ...buildAvatarDetailsColumn<StudentTestResult>({
      isCompactLayout,
      getTitle: (row) => row.student.displayName || `${row.student.firstName} ${row.student.lastName}`,
      getSubtitle: (row) => `PGA ID: ${row.student.pgaId}`,
      getPicture: (row) => row.student.profilePhoto,
      size: 280,
      minSize: 240
    }),
    {
      accessorKey: "testId",
      header: "Test ID",
      size: 110,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => row.original.testId
    },
    {
      accessorKey: "testName",
      header: "Test Name",
      size: 400,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => row.original.testName,
      meta: {
        headerClassName: "hide-header-in-column"
      }
    },
    {
      accessorKey: "level",
      header: "Level",
      size: 70,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => row.original.level
    },
    {
      accessorKey: "testDate",
      header: "Test Date",
      size: 140,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => toFormat(row.original.testDate)
    },
    {
      accessorKey: "isRetake",
      header: "Is Retake",
      size: 90,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => (row.original.isRetake ? "Yes" : "No")
    },
    {
      accessorKey: "score",
      header: "Score",
      size: 90,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => {
        const { score, maxScore } = row.original;
        return `${score} / ${maxScore}`;
      }
    },
    {
      accessorKey: "passed",
      header: "Status",
      size: 110,
      enableSorting: false,
      cell: ({ row }: { row: Row<StudentTestResult> }) => {
        const passed = row.original.passed;
        return (
          <Tag tagType={passed ? "success" : "error"} tagStyle="strong" size="small">
            {passed ? "Passed" : "Failed"}
          </Tag>
        );
      },
      meta: {
        headerClassName: "hide-header-in-column"
      }
    },
    buildActionColumn<StudentTestResult>({
      getActions: () => [],
      onViewClick: (row) => handleViewStudent(row),
      viewButtonTitle: "View Student",
      actionId: () => "",
      setMenu: () => {}
    })
  ];

  return columns;
};

export type TestResultRow = StudentTestResult;
